import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchCautions = createAsyncThunk("cautions/fetchAll", async ({ page = 1, pageSize = 10 } = {}, { rejectWithValue }) => {
  try { const r = await api.get('/Caution', { params: { page, pageSize } }); return r.data; } // PagedResult
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const createCaution = createAsyncThunk("cautions/create", async (data, { rejectWithValue }) => {
  try {
    await api.post('/Caution', data);
    const list = await api.get('/Caution', { params: { page: 1, pageSize: 10 } });
    return list.data; // PagedResult
  } catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const deleteCaution = createAsyncThunk("cautions/delete", async (id, { rejectWithValue }) => {
  try { await api.delete(`/Caution/${id}`); return id; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const updateCautionStatut = createAsyncThunk("cautions/updateStatut", async ({ id, statut }, { rejectWithValue }) => {
  try {
    const r = await api.patch(`/Caution/${id}/statut`, { statut });
    return r.data;
  } catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const downloadCautionPdf = createAsyncThunk("cautions/downloadPdf", async (id, { rejectWithValue }) => {
  try {
    const response = await api.get(`/Caution/${id}/pdf`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `caution-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return id;
  } catch (e) { return rejectWithValue(e.message); }
});

const slice = createSlice({
  name: "cautions",
  initialState: {
    items: [],
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetSuccess: (state) => { state.success = false; },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCautions.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCautions.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(fetchCautions.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(createCaution.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createCaution.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.currentPage = 1;
        state.success = true;
      })
      .addCase(createCaution.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(deleteCaution.fulfilled, (state, action) => {
        state.items = state.items.filter(i => i.id !== action.payload);
        state.totalCount = Math.max(0, state.totalCount - 1);
      })
      .addCase(deleteCaution.rejected, (state, action) => { state.error = action.payload; });
    builder
      .addCase(downloadCautionPdf.rejected, (state, action) => { state.error = action.payload; });
    builder
      .addCase(updateCautionStatut.fulfilled, (state, action) => {
        const updated = action.payload;
        state.items = state.items.map(i => i.id === updated.id ? updated : i);
      })
      .addCase(updateCautionStatut.rejected, (state, action) => { state.error = action.payload; });
  },
});

export const { resetSuccess, clearError } = slice.actions;
export default slice.reducer;
